/**
 * Collapsed stash / next queue chip rendering (canvas).
 */

export function collapseTiers(items, maxChips) {
  var counts = new Map();
  if (!items || !items.length) return [];
  for (var i = 0; i < items.length; i++) {
    var t = Math.max(0, Math.floor(Number(items[i]) || 0));
    counts.set(t, (counts.get(t) || 0) + 1);
  }
  var chips = [];
  counts.forEach(function (count, tier) {
    chips.push({ tier: tier, count: count });
  });
  chips.sort(function (a, b) { return a.tier - b.tier; });
  if (maxChips != null && chips.length > maxChips) {
    chips = chips.slice(0, maxChips);
  }
  return chips;
}

export function drawTierChip(ctx, x, y, size, tier, count, assetSrc) {
  if (!ctx) return;
  var r = size / 2;
  ctx.save();
  ctx.beginPath();
  ctx.arc(x + r, y + r, r, 0, Math.PI * 2);
  ctx.fillStyle = "rgba(255,255,255,0.92)";
  ctx.fill();
  ctx.strokeStyle = "rgba(0, 60, 80, 0.35)";
  ctx.lineWidth = 1.5;
  ctx.stroke();
  if (assetSrc && typeof Image !== "undefined") {
    // Caller may preload; fallback label
  }
  ctx.fillStyle = "#003242";
  ctx.font = "bold " + Math.max(9, Math.floor(size * 0.38)) + "px sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(String(tier), x + r, y + r);
  if (count > 0) {
    var badgeR = Math.max(8, size * 0.22);
    var bx = x + size - badgeR * 0.4;
    var by = y + size - badgeR * 0.4;
    ctx.beginPath();
    ctx.arc(bx, by, badgeR, 0, Math.PI * 2);
    ctx.fillStyle = "#1FA8D0";
    ctx.fill();
    ctx.fillStyle = "#fff";
    ctx.font = "bold " + Math.max(8, Math.floor(badgeR * 1.1)) + "px sans-serif";
    ctx.fillText("x" + count, bx, by + 0.5);
  }
  ctx.restore();
}

export function drawStashStack(ctx, anchorX, anchorY, chips, opts) {
  if (!ctx || !chips || !chips.length) return;
  opts = opts || {};
  var size = opts.size != null ? opts.size : 36;
  var gap = opts.gap != null ? opts.gap : 8;
  var max = opts.maxVisible != null ? opts.maxVisible : 5;
  var list = chips.slice(0, max);
  for (var i = 0; i < list.length; i++) {
    var chip = list[i];
    var cy = anchorY - i * (size + gap);
    drawTierChip(ctx, anchorX - size, cy - size, size, chip.tier, chip.count);
  }
}

export function drawNextChip(ctx, x, y, nextTier, totalRemaining, opts) {
  if (!ctx) return;
  opts = opts || {};
  var size = opts.size != null ? opts.size : 40;
  drawTierChip(ctx, x, y, size, nextTier != null ? nextTier : 0, 0);
  if (totalRemaining > 0) {
    ctx.save();
    ctx.fillStyle = "rgba(0, 40, 55, 0.82)";
    ctx.font = "bold 13px sans-serif";
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    ctx.fillText(String(totalRemaining), x + size + 8, y + size / 2);
    ctx.restore();
  }
}
